import axios from '../../axios';

export type ServiceResponse = {
  id: number;
  type: string;
  title: string;
  titleEn: string;
  titleTr: string;
  content: string;
  contentEn: string;
  contentTr: string;
  imageFile: string;
  imageFileEn: string;
  imageFileTr: string;
  startDate: string;
  endDate: string;
  status: statusEnum;
  viewCount: number;
};

type statusEnum = 'ACTIVE' | 'PASSIVE';

export default async function getCampaing(
  type: any
): Promise<ServiceResponse[]> {
  let res = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/campaign/active`,
    {
      params: {
        type: type,
      },
    }
  );
  return res.data;
}
